import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { RendererExtensionHandlerProps } from '../src/ExcerptExtensionHandler.tsx';

export const ExpandExtensionHandler: LoadableType<RendererExtensionHandlerProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ExpandExtensionHandler" */ '../src/ExpandExtensionHandler.tsx'
				)
			).ExpandExtensionHandler,
	});
